<template>
  <div class="ac-card-content">
    <div class="unarch-header-container">
      <div class="flex-row">
        <img
          src="@shared/assets/img/general/eye.png"
          class="ac-info"
          alt="Information"
        />
        <div class="ac-header">Unarchive Plan</div>
      </div>
    </div>
    <div class="unarch-body-ft-container">
      <div class="ac-body-container">
        <div class="ac-body">
          <div class="flex-row just-between margin-bottom-12">
            <div class="unarch-info">{{ selectedPlan.name }} Plan</div>
            <div class="unarch-info">
              Active: {{ selectedPlan.activeMembers }}
            </div>
          </div>
          <div class="unarch-body-text">
            Please contact your Partner Success Manager directly to unarchive a
            plan, or email
            <a :href="`mailto:${psmEmail}`">{{ psmEmail }}</a>
          </div>
        </div>
      </div>
      <div class="unarch-ft-container">
        <button type="button" class="secondary-button" @click="close">
          Cancel
        </button>
        <button
          class="primary-button active" 
          @click="handleButtonClick"
        >
          {{ !isSmacAdmin ? 'Email' : 'Unarchive' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'UnarchivePlan',
  mixins: [partnerSettingsMixin],
  props: {
    close: Function,
    submit: Function,
    partnerPSM: Object,
  },
  computed: {
    hasActiveMembers() {
      return this.selectedPlan.activeMembers > 0;
    },
    psmEmail() {
      if (this.partnerPSM && this.partnerPSM.email) {
        return this.partnerPSM.email;
      }
      return 'partners@smartac.com';
    },
    emailHref() {
      const planName = encodeURIComponent(this.selectedPlan?.name);
      const partnerName = encodeURIComponent(
        this.$store.state.admin?.corporation?.corporationName ||
          'Unknown Partner'
      );
      const subject = `Unarchive ${planName} Plan Request - ${partnerName}`;
      return `mailto:${this.psmEmail}?subject=${subject}`;
    },
  },
  methods: {
    handleButtonClick() {
      if (!this.isSmacAdmin) {
        window.location.href = this.emailHref;
        this.close();
      } else {
        this.submit();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.unarch-info {
  font-size: 18px;
  font-weight: 600;
}

.unarch-header-container {
  padding: 24px 24px 0px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .ac-header {
    font-size: 1.25rem;
    font-weight: 600;
    margin-left: 12px;
  }

  .ac-info {
    width: 25px;
    object-fit: contain;
    margin-right: 6px;
  }
}

.unarch-body-text {
  margin-top: 38px;
  font-size: 16px;
  color: #7f8290;
  text-align: start;
}

.unarch-body-ft-container {
  margin-top: -16px;
  display: grid;
  gap: 22px;
}

.unarch-ft-container {
  display: flex;
  align-items: end;
  gap: 16px;
  justify-content: end !important;
  margin: 0 24px;

  .secondary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $WHITE;
    border: solid 4px $NBLUE100;
    border-radius: 8px;
    color: $NBLUE100;
    padding: 12px 18px;
    font-weight: 600;

    &.blue {
      background-color: $NBLUE100;
      opacity: 0.3;
      color: $NBLUE100;
    }
  }

  .primary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: solid 4px $NBLUE100;
    background-color: $NBLUE100;
    border-radius: 8px;
    color: $WHITE;
    padding: 12px 18px;
    font-weight: 600;

    &.active {
      background-color: $NBLUE100;
    }

    &.inactive {
      opacity: 0.3;
    }
  }
}
</style>
